module.exports = __webpack_public_path__ + "images/category_lp/pc/lppc-Hikaku_KaitoriCase2_c1ae5d1f280f175b588edfe12e05d7f9.png";